module.exports = __webpack_public_path__ + "img/close_full_x2.43828bf8.png";